import { ProductionFigureThemeModeConfig } from './types';

const light: ProductionFigureThemeModeConfig = {
  productionFigure: {
    normalButtonBGColor: '#0775bc',
    normalButtonBorderColor: '2px solid #267DAC',
    cardBGColor: 'linear-gradient(to bottom, #33EEff55, #FFFFFF55)',
    cardBorderColor: '1px double black',
    profileHeaderBGColor: '#FFFFFFAA',
    profileHeaderFontColor: 'blue',
  },
};

export default light;
